import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import pt from "./locales/pt.json";

// Texts live in locales/*.json so the build-time prerender
// (scripts/prerender.js) writes the same words into the static HTML.
const resources = {
  en: { translation: en },
  pt: { translation: pt },
};

const LANG_KEY = "lang";

// The URL decides the language: Portuguese at the root, English under /en.
// Every page exists as static HTML in both, so crawlers and AI readers get a
// stable, indexable address per language instead of one URL whose content
// depends on the visitor's browser.
const isEnPath = (path) => path === "/en" || path.startsWith("/en/");
const urlLanguage = isEnPath(window.location.pathname) ? "en" : "pt";

/** Router basename for the language in the URL. */
export const LANG_BASE = urlLanguage === "en" ? "/en" : "";

/** The same page in the other language, e.g. /blog/x <-> /en/blog/x. */
export const pathInLanguage = (lng, path = window.location.pathname) => {
  const bare = isEnPath(path) ? path.slice(3) || "/" : path;
  if (lng === "en") return bare === "/" ? "/en" : `/en${bare}`;
  return bare;
};

/** Switches language by moving to the other URL and remembers the choice. */
export const switchLanguage = (lng) => {
  try { localStorage.setItem(LANG_KEY, lng); } catch (e) { /* storage blocked */ }
  if (lng === urlLanguage) return;
  window.location.assign(pathInLanguage(lng) + window.location.search + window.location.hash);
};

// First visit only: suggest the browser's language once, then respect the
// URL. Crawlers are never redirected, so each URL keeps its own language.
const BOT_UA = /bot|crawl|spider|slurp|preview|headless|lighthouse|google|bing|gpt|claude|perplexity|anthropic/i;
(function suggestLanguageOnce() {
  try {
    if (localStorage.getItem(LANG_KEY) || BOT_UA.test(navigator.userAgent) || navigator.webdriver) return;
    const preferred = ((navigator.languages && navigator.languages[0]) || navigator.language || "").toLowerCase();
    const browserLang = preferred.startsWith("pt") ? "pt" : "en";
    localStorage.setItem(LANG_KEY, browserLang);
    if (browserLang !== urlLanguage) {
      window.location.replace(pathInLanguage(browserLang) + window.location.search + window.location.hash);
    }
  } catch (e) { /* storage blocked: stay on the URL's language */ }
})();

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: urlLanguage,
    fallbackLng: "en",

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
